import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M20.25 11.7778V9.55556C20.25 6.48731 17.4518 4 14 4C10.5482 4 7.75 6.48731 7.75 9.55556V11.7778M14 16.7778V19M10 24H18C20.1002 24 21.1503 24 21.9525 23.6367C22.6581 23.3171 23.2317 22.8072 23.5913 22.18C24 21.4669 24 20.5335 24 18.6667V17.1111C24 15.2443 24 14.3108 23.5913 13.5978C23.2317 12.9706 22.6581 12.4607 21.9525 12.1411C21.1503 11.7778 20.1002 11.7778 18 11.7778H10C7.8998 11.7778 6.8497 11.7778 6.04754 12.1411C5.34193 12.4607 4.76825 12.9706 4.40873 13.5978C4 14.3108 4 15.2443 4 17.1111V18.6667C4 20.5335 4 21.4669 4.40873 22.18C4.76825 22.8072 5.34193 23.3171 6.04754 23.6367C6.8497 24 7.8998 24 10 24Z",
      stroke: "#401D42",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }